import { render, staticRenderFns } from "./PrivacyPolicyClient.vue?vue&type=template&id=54ed95cd"
import script from "./PrivacyPolicyClient.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports